import { Fragment } from "react";
import { Field } from "../types";
import { RenderSingleField } from "./renderSingleField";
import { RenderMultipleFields } from "./renderMultipleFields";

export const RenderFieldModal = (field: Field) => {
  return (
    <Fragment>
      {field.type === "modal" && Array.isArray(field.fields)
        ? field.fields?.map((field: Field, index: number) =>
            RenderMultipleFields(field, index),
          )
        : RenderSingleField(field)}
    </Fragment>
  );
};
